import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const ContainerContent = styled.div`
  background-color: ${theme.colors.neutral.white};
  padding: ${theme.spacing.md};
  display: grid;

  border-bottom-left-radius: ${theme.shapes.borderRadius.md};
  border-bottom-right-radius: ${theme.shapes.borderRadius.md};
`

export const Container = styled.div`
  h1 {
    font-family: ${theme.typography.family.bold};
    margin-top: ${theme.spacing.sm};
    margin-bottom: ${theme.spacing['2xl']};
    color: ${theme.colors.neutral.black};
  }
`
interface DraftsHeadingDataProps {
  width?: number
}

export const DraftsHeadingData = styled.th<DraftsHeadingDataProps>`
  width: ${({ width }) => (width ? `${width}px` : 'auto')};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.xs};
  text-align: left;
  padding: ${theme.spacing.xm} ${theme.spacing.sm} 12px;
  color: ${theme.colors.neutral.black};
  border-bottom: 1px solid ${theme.colors.neutral.lighthover};
  white-space: nowrap;
  @media screen and (min-width: ${theme.breakpoints.xl}px) {
    white-space: nowrap;
  }
  @media only screen and (max-width: ${theme.breakpoints.md}px) {
    padding: ${theme.spacing.xs} ${theme.spacing.sm};
    font-weight: ${theme.typography.weight.md};
    font-size: ${theme.typography.sizes['2xs']};
  }
`

export const DraftsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
`

export const DraftsRow = styled('tr')`
  width: 100%;
  :nth-of-type(even) {
    background-color: ${theme.colors.neutral[100]};
    border-radius: ${theme.shapes.borderRadius.sm};
    td:first-of-type {
      border-top-left-radius: ${theme.shapes.borderRadius.md};
      border-bottom-left-radius: ${theme.shapes.borderRadius.md};
    }
    td:last-of-type {
      border-top-right-radius: ${theme.shapes.borderRadius.md};
      border-bottom-right-radius: ${theme.shapes.borderRadius.md};
    }
  }
`

export const PaginationWrapper = styled.div`
  margin-top: ${theme.spacing.xl};

  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const ReportBtnContainer = styled.div`
  width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
`
